import moment from 'moment'

export default {
    methods: {
        diffInterpreterRequestOrderPayments(obj, array) {
            // request order payment received/paid/checked
            if(obj.received)
                obj.received.__new 
                    ? array.push({ 
                        message: `Marcou como recebido`,
                    }) 
                    : array.push({
                        message: 'Desmarcou como recebido',
                    })
            if(obj.paid)
                obj.paid.__new  
                    ? array.push({
                        message: 'Marcou como pago',
                    })
                    : array.push({
                        message: 'Desmarcou como pago',
                    })
            if(obj.checked)
                obj.checked.__new  
                    ? array.push({
                        message: 'Marcou como conferido',
                    })
                    : array.push({
                        message: 'Desmarcou como conferido',
                    })
            
            // request order payment method
            if(obj.paymentMethodId && obj.paymentMethod) 
                array.push({
                    message: `Alterou para ${obj.paymentMethod.name.__new}`,
                }) 
            // payment code
            if(obj.code && obj.code.__new) 
                array.push({
                    message: `Alterou o códido para ${obj.code.__new}`
                })
            // payment deadline date
            if(obj.deadlineDatetime && obj.deadlineDatetime.__new)
                array.push({
                    message: `Alterou a data de vencimento para ${moment(obj.deadlineDatetime.__new).format('DD/MM/YYYY hh:mm')}`
                })
            // payment amount
            if(obj.amount && obj.amount.__new)
                array.push({
                    message: `Alterou o valor para ${this.utils.formatMoney(obj.amount.__new, 2, 'R$', '.', ',')}`
                })
            
        },  

        diffInterpreterRequestOrderProducts(obj, array) {
            if(obj.productId && obj.product) 
                array.push({
                    message: `Alterou o produto para ${obj.product.name.__new}`
                })
            
            if(obj.unitPrice && obj.unitPrice.__new)
                array.push({
                    message: `Alterou o valor unitário para ${this.utils.formatMoney(obj.unitPrice.__new, 2, 'R$', '.', ',')}`
                })
            
            if(obj.unitDiscount && obj.unitDiscount.__new)
                array.push({
                    message: `Alterou o valor unitário de desconto para ${this.utils.formatMoney(obj.unitDiscount.__new, 2, 'R$', '.', ',')}`
                })

            if(obj.quantity && obj.quantity.__new)
                array.push({
                    message: `Alterou a quantidade para ${obj.quantity.__new}`
                })
        },

        diffInterpreterRequestOrderServices(obj, array) {
            if(obj.serviceId && obj.service)
                array.push({
                    message: `Alterou o serviço para ${obj.service.name.__new}`
                })

            if(obj.price && obj.price.__new)
                array.push({
                    message: `Alterou o valor para ${this.utils.formatMoney(obj.price.__new, 2, 'R$', '.', ',')}`
                })

            if(obj.discount && obj.discount.__new)
                array.push({
                    message: `Alterou o valor do desconto para ${this.utils.formatMoney(obj.discount.__new, 2, 'R$', '.', ',')}`
                })
        },

        diffInterpreterRequest(obj, array) {
            if(obj.deliveryDate && obj.deliveryDate.__new) 
                array.push({
                    message: `Alterou a data de entrega para ${moment(obj.deliveryDate.__new).format('DD/MM/YYYY hh:mm')}`
                })
            
            if(obj.isScheduled && obj.isScheduled.__new)
                array.push({
                    message: obj.isScheduled.__new
                        ? 'Agendou o pedido'
                        : 'Retirou o agendamento do pedido'
                })

            if(obj.phoneLineId && obj.phoneLineId.__new)
                array.push({
                    message: `Alterou a linha telfônica para ${this.VXORM.PhoneLine.find(obj.phoneLineId.__new).name}`
                })

            if(obj.status && obj.status.__new) {
                array.push({
                    message: `Alterou o status do pedido para "${this.translateRequestStatus(obj.status.__new)}"`
                })
            }
        },

        diffInterpreterRequestOrder(obj, array) {
            if(obj.obs)
                array.push({
                    message: `Alterou a observação para "${obj.obs.__new}"`
                })

            if(obj.promotionChannelId)
                array.push({
                    message: `Alterou o canal de venda para ${this.VXORM.PromotionChannel.find(obj.promotionChannelId.__new).name}`
                })
        },

        diffInterpreterResponsibleUser(obj, array) {
            if(obj.id && obj.name)
                array.push({
                    message: `Alterou o usuário responsável para ${obj.name.__new}`
                })
        },

        diffInterpreterRequestContact(obj, array) {
            //contact address
            if(obj.contactAddress) {
                array.push({
                    message: 'Endereço de entrega',
                    isSection: true,
                    action: 'edited'
                })

                if(obj.contactAddress.complement && obj.contactAddress.complement.__new)
                    array.push({
                        message: `Alterou o complemento para ${obj.contactAddress.complement.__new}`
                    })

                if(obj.contactAddress.number && obj.contactAddress.number.__new)
                    array.push({
                        message: `Alterou o número para ${obj.contactAddress.number.__new}`
                    })
                
                let address = obj.contactAddress.address
                if(address) {
                    if(address.name && address.name.__new) 
                        array.push({
                            message: `Alterou o logradouro para ${address.name.__new}`
                        })

                    if(address.neighborhood && address.neighborhood.__new) 
                        array.push({
                            message: `Alterou o bairro para ${address.neighborhood.__new}`
                        })

                    if(address.cep && address.cep.__new) 
                        array.push({
                            message: `Alterou o CEP para ${address.cep.__new}`
                        })
                }

                if((obj.contactAddress.lat && obj.contactAddress.lat.__new) 
                    || (obj.contactAddress.lng && obj.contactAddress.lng.__new))
                    array.push({
                        message: `Latitude e longitude foram atualizados`
                    })
            }
            // contact phone
            if(obj.contactPhone) {
                array.push({
                    message: `Telefone do pedido`,
                    isSection: true,
                    action: 'edited'
                })

                if(obj.contactPhone.number && obj.contactPhone.number.__new)
                    array.push({
                        message: `Alterou o número para ${this.utils.formatPhone(obj.contactPhone.number.__new)}`
                    })                
            }
            // contact
            if(obj.contact) {
                if(obj.contact.name || obj.contact.obs)
                    array.push({
                        message: 'Contato',
                        isSection: true,
                        action: 'edited'
                    })
                if(obj.contact.name && obj.contact.name.__new)
                    array.push({
                        message: `Alterou o nome para ${obj.contact.name.__new}`
                    })

                if(obj.contact.obs && obj.contact.obs.__new)
                    array.push({
                        message: `Alterou a observação para ${obj.contact.obs.__new}`
                    })
            }
        }
    }
}